module.exports = __webpack_public_path__ + "static/banner-07465b74183fbc5b3a4ee8f63c0bc040.png";